import { render } from "./SortHeader.vue?vue&type=template&id=56e6cf26"
import script from "./SortHeader.vue?vue&type=script&lang=js"
export * from "./SortHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__